<ion-header class="full-page-only" [class.show_premium]="show_premium">
  <ion-toolbar>
    <ion-buttons slot="start" class="logo">
      <img class="main-img" src="assets/Skutt-Original-Horizontal-Logo_PMS-167_RegisteredTMWhiteSun.png"/>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" class="has-header home-page" [class.show_premium]="show_premium">
  <ion-img [src]="logoUrl" class="login-logo"></ion-img>
  <ion-list id="login-list">
    <ion-item id="login-username-item" name="email" (click)="focusInput('email')">
      <ion-label fixed>{{ 'HOME.EMAIL' | translate }}<sup>{{ 'HOME.REQUIRED_FIELD' | translate }}</sup></ion-label>
      <ion-input id="email" name="username" type="text" [(ngModel)]="loginEmail"></ion-input>
    </ion-item>
    <ion-item id="login-password-item" name="password" (click)="focusInput('password')">
      <ion-label fixed>{{ 'HOME.PASSWORD' | translate }}<sup>{{ 'HOME.REQUIRED_FIELD' | translate }}</sup></ion-label>
      <app-show-hide-password>
        <ion-input id="password" name="password" type="password" [(ngModel)]="loginPassword"></ion-input>
      </app-show-hide-password>
    </ion-item>
    <ion-item id="login-remember-item" >
      <ion-label>{{ 'HOME.REMEMBER_ME' | translate }}</ion-label>
      <ion-toggle name="rememberMe" [(ngModel)]="loginRemember" (ionChange)="onRememberMeChange($event)"></ion-toggle>
    </ion-item>
  </ion-list>
  <div class="login" [class.disabled]="isLoggingIn || loginBtnText != 'Sign In'"
    [class.show_premium]="show_premium">
    <ion-button type="submit" size='full' [disabled]="isLoggingIn || loginBtnText != 'Sign In'"
      (click)="loginClick()">
      <span *ngIf="!isLoggingIn">{{ 'HOME.SIGN_IN' | translate }}</span>
      <ion-spinner name="bubbles" *ngIf="isLoggingIn"></ion-spinner>
    </ion-button>
    <ion-button size='full' *ngIf="isLoggingIn" (click)="cancelLogin()">
      <span>{{ 'HOME.CANCEL_LOGIN' | translate }}</span>
    </ion-button>
  </div>

  <div id="forgot-password" [class.show_premium]="show_premium">
    <span><a (click)="forgotPassword()">{{ 'HOME.FORGOT_PASSWORD' | translate }}</a></span>
    <span><a (click)="createUser()">{{ 'HOME.SIGN_UP' | translate }}</a></span>
  </div>

  <div id="login-hint">
    <div><ion-icon name="alert"></ion-icon>&nbsp;{{ 'HOME.EMAIL_CASE_SENSITIVE' | translate }}</div>
  </div>
  <div id="login-markdown3" *ngIf="errorText" class="error-box"
     [class.show_premium]="show_premium">
    <p>{{errorText}}</p>
  </div>
</ion-content>
